import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import Helmet from "react-helmet"
import logo from "../assets/logo.svg"

export default withTranslation()(
  withRouter(
    class AdminLogin extends Component {
      state = { password: "", error: false, loading: false }

      checkAdminPassword = async (password) => {
        const { forceUpdate } = this.props

        this.setState({ loading: true })

        await fetch(
          `${process.env.REACT_APP_SERVER_URL}/checkAdminPassword?password=${password}`,
          {
            method: "POST",
            headers: {},
          }
        )
          .then(async (response) => {
            if (response.status !== 200) {
              this.setState({ error: true })
              return
            }

            this.setState({ error: false })
            localStorage.setItem("password", password)
            forceUpdate()
          })
          .finally(() => this.setState({ loading: false }))
      }

      render() {
        const { t, history } = this.props
        const { password, loading, error } = this.state

        return (
          <>
            <Helmet>
              <title>Lapwing - Login</title>
            </Helmet>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                backgroundColor: "#E6E2B1",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  maxHeight: "100%",
                  overflow: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#E6E2B1",
                    textAlign: "center",
                    padding: "32px 0 16px 0",
                  }}
                  className="notSelectable"
                >
                  <img alt="" src={logo} style={{ marginBottom: "48px" }} />
                  <Typography
                    variant="h4"
                    style={{
                      fontSize: "30px",
                      fontWeight: 600,
                      margin: "0 32px 8px 32px",
                      color: "#181818",
                    }}
                  >
                    {t`Welcome to the Lapwing app`}
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: 300,
                      margin: "0 32px",
                      color: "#181818",
                    }}
                  >{t`Enter your password to get started`}</Typography>
                  <TextField
                    label={t`Password`}
                    variant="outlined"
                    type="password"
                    value={password}
                    onChange={(event) =>
                      this.setState({
                        error: false,
                        password: event.target.value,
                      })
                    }
                    onKeyPress={(event) => {
                      if (event.key === "Enter" && event.target.value) {
                        this.checkAdminPassword(event.target.value)
                      }
                    }}
                    helperText={error ? t`Wrong password` : " "}
                    style={{
                      marginTop: "48px",
                      width: "256px",
                      textTransform: "none",
                    }}
                  />
                  <Button
                    variant="outlined"
                    style={{
                      marginTop: "16px",
                      width: "256px",
                    }}
                    size="large"
                    disabled={!password || loading}
                    onClick={() => {
                      if (password) {
                        this.checkAdminPassword(password)
                      }
                    }}
                  >{t`Log in`}</Button>
                  <Button
                    style={{
                      marginTop: "8px",
                      width: "256px",
                    }}
                    size="large"
                    onClick={() => history.push("/")}
                  >{t`Go back`}</Button>
                </div>
              </div>
            </div>
          </>
        )
      }
    }
  )
)
